import {call, put} from "typed-redux-saga";
import {Api} from "modules/utils";
import {
	fetchAchievementsCountFailed,
	fetchAchievementsCountSuccess, fetchUserLevelFailed, fetchUserLevelSuccess,
	IPayloadAchievementsCount, IPayloadUserLevel,
} from "modules/actions";
import {ISagaAction} from "modules/types";

export const requestGamezoneBaner = function* ({payload}: ISagaAction<IPayloadAchievementsCount>) {
	try {
		const result = yield* call(Api.GamezoneBaner.get, payload);
		yield* put(fetchAchievementsCountSuccess(result.success));
	} catch (err) {
		yield* put(fetchAchievementsCountFailed());
	}
};

export const requestGamezoneLevel = function* ({payload}: ISagaAction<IPayloadUserLevel>) {
	try {
		const result = yield* call(Api.GamezoneBaner.getUserLevel, payload);
		yield* put(fetchUserLevelSuccess(result.success));
	} catch (err) {
		yield* put(fetchUserLevelFailed());
	}
};